import { Link } from "react-router-dom";
import { cn, LOGIN_ROLES } from "@/lib/utils";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";
import { adminMenu, crmHeadMenu, financeTeamMenu, labHeadMenu, salesOpsMenu, labTeamMenu, inventoryTeamMenu, regionHeadMenu, relationshipManagerMenu } from "../utils";


const Sidebar = ({ handleClose }: { handleClose?: () => void }) => {
  const [menu, setMenu] = useState<any>(null);

  const loggedInUserData = useSelector(
    (state: RootState) => state.currentData.loggedInUserData
  );

  function getSideMenu(loggedInUserData: any): any {
    const roles = loggedInUserData?.roles.flat() || [];

    if (roles.includes(LOGIN_ROLES.SUPER_ADMIN)) {
      return adminMenu;
    } else if (roles.includes(LOGIN_ROLES.CRM_HEAD)) {
      return crmHeadMenu;
    } else if (roles.includes(LOGIN_ROLES.FINANCE_TEAM)) {
      return financeTeamMenu;
    } else if (roles.includes(LOGIN_ROLES.SALES_OPS)) {
      return salesOpsMenu;
    } else if (roles.includes(LOGIN_ROLES.LABS_TEAM_HEAD)) {
      return labHeadMenu;
    } else if (roles.includes(LOGIN_ROLES.LABS_TEAM)) {
      return labTeamMenu;
    } else if (roles.includes(LOGIN_ROLES.INVENTORY_TEAM)) {
      return inventoryTeamMenu;
    } else if (roles.includes(LOGIN_ROLES.REGION_HEAD)) {
      return regionHeadMenu;
    } else if (roles.includes(LOGIN_ROLES.RELATIONSHIP_MANAGER)) {
      return relationshipManagerMenu;
    } else {
      return null;
    }
  }


  useEffect(() => {
    setMenu(
      getSideMenu(loggedInUserData)
    );
  }, [loggedInUserData]);

  return (
    <>
      {menu?.map((menu: any) => {
        const isActive =
          location.pathname === menu.to ||
          location.pathname.startsWith(menu.to + "/");

        return (
          <Link
            to={menu.to}
            key={menu.title}
            onClick={handleClose}
            className={cn(
              "flex relative group transition-all text-[15px] flex-row items-center justify-between gap-2 mb-[10px] text-white py-3 px-3",
              isActive ? "text-primary" : "text-gray-500 hover:text-primary"
            )}
          >
            <div className="flex gap-2">
              <menu.icon
                className={cn(
                  "stroke-white stroke-1 group-hover:stroke-2",
                  isActive ? "stroke-2" : ""
                )}
              />
              <span
                className={cn(
                  "text-white text-center font-extralight group-hover:font-bold",
                  isActive ? "font-bold" : ""
                )}
              >
                {menu.title}
              </span>
            </div>
            {isActive ? (
              <div className="h-2 w-2 bg-primary rounded-full" />
            ) : (
              <></>
            )}
          </Link>
        );
      })}
    </>
  );
};

export default Sidebar;